import { defineMessage } from 'react-intl';

export const userCommonI18n = {
  managedByUser: defineMessage({
    id: 'common:user.managed-by-user',
    defaultMessage: 'Managed by {name}'
  }),
  managedUser: defineMessage({
    id: 'common:user.managed-user',
    defaultMessage: 'Managed user'
  }),
  managedUserShort: defineMessage({
    id: 'common:user.managed-user.short',
    defaultMessage: 'Managed'
  }),
  parentUser: defineMessage({
    id: 'common:user.parent-user',
    defaultMessage: 'Parent user'
  }),
  user: defineMessage({
    id: 'common:user.user',
    defaultMessage: 'User'
  }),
  userAccount: defineMessage({
    id: 'common:user.user-account',
    defaultMessage: 'User account'
  })
};
